








































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../components/MonthSelector.vue";
import VoucherTemplateVue from "../components/VerifyVoucher/VoucherTemplate.vue";
import SzTypes from "../data/SzTypes";
import OtherInvoiceTypes from "../data/OtherInvoiceTypes"
import DepartList from "../data/DepartList"

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        "voucher-template": VoucherTemplateVue,
    }
})
export default class VerifyOthers extends Vue {
    shouldFetch: boolean = false
    curTp: OtherBill.OtherBill | string = ""
    voucherTemplate: boolean = false;
    typeList= OtherInvoiceTypes;
    deptList = DepartList;
    //改变时间
    period: string[] = []; // 日期
    changeDate(date: string[], ) {
        this.period = date;
        this.fetchData();
    }
    // 分页
    currentPage: number = 1;
    pageSize: number = 20;
    totalElements: number = 0;
    handleCurrentChange(val: any) {
        this.currentPage = val;
        this.fetchData();
    }
    // 获取数据
    list: OtherBill.OtherBill[] = []
    checkedInvoices: OtherBill.OtherBill[] = []
    fetchData() {
        this.shouldFetch = false;
        Vue.axios
            .get(
                `otherinvoices/templates?period=${this.period}&accountBookId=${this.$store.state.accountBook.id}&cate=4&page=${this.currentPage - 1}&size=${this.pageSize}`)
            .then(res => {
                this.checkAll = this.judgeAllChecked(res.data.others.content);
                this.list = res.data.others.content
                this.totalElements = res.data.others.totalElements
            });
    }
    //是否全选
    checkAll: boolean = false
    // 多选functions
    selectAll(val: boolean) {
        if (val) {
            this.list.forEach((v: OtherBill.OtherBill) => {
                if (!v.checked) {
                    v.checked = true;
                }
            })
        } else {
            this.list.forEach((v: OtherBill.OtherBill) => {
                v.checked = false;
            })
        }
    }
    @Watch("list", { deep: true })
    checkedChange(val: OtherBill.OtherBill[]) {
        let all = val.length > 0 ? true : false;
        if (val.length > 0) {
            for (let i = 0; i < val.length; i++) {
                if (!val[i].checked) {
                    all = false;
                    this.removeElement(val[i]);
                } else {
                    if (!this.judgeInclude(val[i])) this.checkedInvoices.push(val[i]);
                }
            }
        }
        this.checkAll = all;
    }
    judgeInclude(v: OtherBill.OtherBill) {
        for (let i = 0; i < this.checkedInvoices.length; i++) {
            if (this.checkedInvoices[i].id === v.id) return true;
        }
        return false
    }
    judgeAllChecked(content: OtherBill.OtherBill[]) {
        let all = content.length > 0 ? true : false;;
        for (let i = 0; i < content.length; i++) {
            let bool = this.judgeInclude(content[i]);
            content[i].checked = bool;
            if (!bool) all = false;
        }
        return all;
    }
    removeElement(v: any) {
        for (let i = 0; i < this.checkedInvoices.length; i++) {
            if (this.checkedInvoices[i].id === v.id) this.checkedInvoices.splice(i, 1);
            break;
        }
    }
    isMulti: boolean = false;

    multiTemp() {
        this.curTp = "";
        this.isMulti = true;
        this.voucherTemplate = true;
    }
    // 选择凭证
    chooseTp(index: number) {
        this.curTp = this.list[index];
        this.voucherTemplate = true;
    }
    // 使用凭证
    useTp(tp:OtherBill.OtherBill) {
        if (!this.isMulti) {
            let curTp = < OtherBill.OtherBill>this.curTp
            if (curTp.voucherTemplateId != null) curTp.voucherTemplateId = tp.id;
            Vue.axios
                .put(
                    `otherinvoices`, this.curTp)
                .then(res => {
                    this.voucherTemplate = false;
                    this.fetchData();
                });
        } else {
            Vue.axios
                .put(
                    `otherinvoices/multi`, {
                        otherInvoiceList: this.checkedInvoices,
                        voucherTemplateId: tp.id
                    })
                .then(res => {
                    this.voucherTemplate = false;
                    this.checkedInvoices = [];
                    this.fetchData();
                });
        }
        this.isMulti = false
    }
}
